if (!customElements.get("toggle-cross-sell")) {
  customElements.define("toggle-cross-sell", class ToggleCrossSell extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.mainProductForm = document.getElementById(this.getAttribute("form"));
      if (!this.mainProductForm) return;
      this.button = this.mainProductForm.querySelector('button[type="submit"]');
      if (!this.button) return;
      this.available = !this.button.disabled;
      this.products = [...this.querySelectorAll(".toggle-cross-sell__product")];
      let remembered;
      try { remembered = localStorage.getItem("iphoneType"); } catch {}
      this.products.forEach((product) => {
        const select = product.querySelector("select");
        if (select?.hasAttribute("data-is-iphone-selector") && remembered) {
          const option = [...select.options].find((option) => !option.disabled && option.textContent.trim() === remembered);
          if (option) select.value = option.value;
        }
        this.syncProduct(product);
      });
      this.addEventListener("change", (event) => {
        const product = event.target.closest(".toggle-cross-sell__product");
        if (!product || !event.target.matches("select")) return;
        this.syncProduct(product);
        const checkbox = product.querySelector('input[type="checkbox"]');
        checkbox.checked = !checkbox.disabled;
        if (event.target.hasAttribute("data-is-iphone-selector")) {
          try { localStorage.setItem("iphoneType", event.target.selectedOptions[0].textContent.trim()); } catch {}
        }
      }, { signal });
      this.addEventListener("click", (event) => {
        if (event.target.closest("input, select, option, label, a, button")) return;
        const checkbox = event.target.closest(".toggle-cross-sell__product")?.querySelector('input[type="checkbox"]');
        if (checkbox && !checkbox.disabled) checkbox.checked = !checkbox.checked;
      }, { signal });
      this.mainProductForm.addEventListener("variant:change", (event) => {
        this.available = Boolean(event.detail.variant?.available);
        queueMicrotask(() => {
          this.button.disabled = this.pending || !this.available;
        });
      }, { signal });
      window.addEventListener("click", (event) => {
        const button = event.target.closest?.('button[type="submit"], input[type="submit"]');
        if (button?.form !== this.mainProductForm) return;
        this.submit(event);
      }, { capture: true, signal });
      window.addEventListener("submit", (event) => {
        if (event.target === this.mainProductForm) this.submit(event);
      }, { capture: true, signal });
      window.addEventListener("pageshow", () => this.products.forEach((product) => this.syncProduct(product)), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    syncProduct(product) {
      const select = product.querySelector("select");
      const checkbox = product.querySelector('input[type="checkbox"]');
      if (!select) return;
      const option = select.selectedOptions[0];
      checkbox.dataset.variantId = option?.value || "";
      checkbox.disabled = !option || option.disabled;
      if (checkbox.disabled) checkbox.checked = false;
      if (!option) return;
      const price = product.querySelector(".toggle-cross-sell__product-price");
      if (price) price.textContent = option.dataset.price;
      const compare = product.querySelector(".toggle-cross-sell__product-compare-at-price");
      const badge = product.querySelector(".toggle-cross-sell__product-badge-discount");
      if (compare) {
        compare.textContent = option.dataset.compareAtPrice || "";
        compare.style.display = option.dataset.compareAtPrice ? "block" : "none";
      }
      if (badge) {
        badge.textContent = option.dataset.discountPercentage || "";
        badge.style.display = option.dataset.compareAtPrice ? "flex" : "none";
      }
      const image = product.querySelector(".toggle-cross-sell__product-image img");
      if (image && option.dataset.variantImage) image.src = option.dataset.variantImage;
    }

    async submit(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.pending || !this.available) return;
      const form = this.mainProductForm;
      if (!form.reportValidity()) return;
      const data = new FormData(form);
      if (!data.get("id")) return;
      const error = this.querySelector('[role="alert"]');
      error.hidden = true;
      const main = { id: data.get("id"), quantity: Number(data.get("quantity") || 1) };
      if (data.get("selling_plan")) main.selling_plan = data.get("selling_plan");
      for (const [key, value] of data) {
        const property = key.match(/^properties\[(.*)\]$/);
        if (property) (main.properties ||= {})[property[1]] = value;
      }
      const items = [main];
      this.products.forEach((product) => {
        this.syncProduct(product);
        const checkbox = product.querySelector('input[type="checkbox"]');
        if (checkbox.checked && !checkbox.disabled && checkbox.dataset.variantId) {
          items.push({ id: checkbox.dataset.variantId, quantity: 1 });
        }
      });
      this.pending = true;
      this.button.disabled = true;
      this.button.setAttribute("aria-busy", "true");
      let errorMessage = this.dataset.errorMessage;
      try {
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) {
          errorMessage = typeof result.description === "string" ? result.description : this.dataset.errorMessage;
          throw new Error(errorMessage);
        }
        if (typeof window.openNativeCartDrawer === "function") {
          try { await window.openNativeCartDrawer(result.items || [result]); }
          catch { window.location.assign(window.Shopify.routes.root + "cart"); }
        } else {
          window.location.assign(window.Shopify.routes.root + "cart");
        }
      } catch (exception) {
        error.textContent = errorMessage;
        error.hidden = false;
      } finally {
        this.pending = false;
        this.button.disabled = !this.available;
        this.button.removeAttribute("aria-busy");
      }
    }
  });
}
